/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {IssueInterface} from '@/store/modules/issues/types';

export interface SearchStateInterface {
    searchIssue: SearchIssueInterface;
    searchCustomerSupport: SearchCustomerSupportInterface;
}

export interface SearchIssueInterface {
    term: string;
    gameId: number | undefined;
    results: IssueInterface[];
    totalResults: number;
    pagination: any;
}

export interface SearchCustomerSupportInterface {
    term: string;
    results: IssueInterface[];
}

export interface SearchFilterInterface {
    searchTerm: string;
    gameId: number;
    orderByDate: string;
    orderByVote: string;
    category: string;
    status: string;
    itemsPerPage: number;
}




/**
 * Search by type.
 *
 */
export enum SearchByType {
    TOP_VOTED = 0,
    NEWEST = 1,
    OLDEST = 2,
}

/**
 * Search by Status.
 *
 */
export enum StatusType {
    UNCONFIRMED = 0,
    CONFIRMED = 1,
    ACKNOWLEDGED = 2,
    FIXED = 3,
    BY_DESIGN = 4,
    INVALID = 5,
    EXPIRED = 7,
    DUPLICATED = 8,
    CLOSED = 9,
}
